import {
  FETCH_CITIES,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILED,
  FETCH_SUBURBS,
  FETCH_SUBURBS_SUCCESS,
  FETCH_SUBURBS_FAILED,
  FETCH_PROVINCE,
  FETCH_PROVINCE_SUCCESS,
  FETCH_PROVINCE_FAILED,
  FETCH_WEBSITE_AREAS_START,
  FETCH_WEBSITE_AREAS_SUCCESS,
  FETCH_WEBSITE_AREAS_FAILED,
  FETCH_PP_CITIES,
  FETCH_PP_CITIES_SUCCESS,
  FETCH_PP_CITIES_FAILED,
  FETCH_PP_SUBURBS_SUCCESS
} from "../store/types";

export const INITIAL_STATE = {
  city: null,
  suburb: null,
  websiteArea: null,
  ppcities: null,
  ppsuburbs: null,
  loading: false,
  success: false,
  completed: false,
  error: {
    flag: false,
    msg: null
  }
};

export const citiesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROVINCE:
      return {
        ...state,
        loading: true
      };
    case FETCH_PROVINCE_SUCCESS:
      return {
        ...state,
        city: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case FETCH_PROVINCE_FAILED:
      return INITIAL_STATE;
    case FETCH_CITIES:
      return {
        ...state,
        loading: true
      };
    case FETCH_PP_CITIES_SUCCESS:
      return {
        ...state,
        ppcities: action.payload
      }
    case FETCH_PP_SUBURBS_SUCCESS:
      return {
        ...state,
        ppsuburbs: action.payload
      }
    case FETCH_CITIES_SUCCESS:
      return {
        ...state,
        city: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case FETCH_CITIES_FAILED:
      return INITIAL_STATE;
    case FETCH_SUBURBS:
      return {
        ...state,
        loading: true
      };
    case FETCH_WEBSITE_AREAS_START:
      return {
        ...state,
        loading: true
      };
    case FETCH_WEBSITE_AREAS_SUCCESS:
      return {
        ...state,
        websiteArea: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case FETCH_WEBSITE_AREAS_FAILED:
      return INITIAL_STATE;
    case FETCH_SUBURBS:
      return {
        ...state,
        loading: true
      };
    case FETCH_SUBURBS_SUCCESS:
      return {
        ...state,
        suburb: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case FETCH_SUBURBS_FAILED:
      return INITIAL_STATE;

    default:
      return state;
  }
};


